import { PropsWithChildren } from "react";

export default function Empty({ children }: PropsWithChildren) {
  return children;
}
